import { render, staticRenderFns } from "./PermissionCheckbox.vue?vue&type=template&id=1f9fbd90&"
import script from "./PermissionCheckbox.vue?vue&type=script&lang=js&"
export * from "./PermissionCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports